import { useState, useEffect } from "react";
import { useAuthcontext } from "./useAuthcontext";

//firebase imports
import { createUserWithEmailAndPassword, updateProfile } from "firebase/auth";
import { auth, db } from "../firebase/config"
// import { ref, getDownloadURL, uploadBytes } from "firebase/storage";
import { collection, doc, setDoc } from "firebase/firestore";



export const useSignup = () => {

  const [isCancelled, setIsCancelled] = useState(false)
  const [error, setError] = useState(null)
  const [isPending, setIsPending] = useState(false)
  const { dispatch } = useAuthcontext()

  const signup = async (email, password, displayName) => {
    setError(null)
    setIsPending(true)
  
    try {
      // signup
      const res = await createUserWithEmailAndPassword(auth, email, password)

      if (!res) {
        throw new Error('Could not complete signup')
      }

      // // upload user thumbnail
      // const path = `thumbnails/${res.user.uid}/${thumbnail.name}`
      // const imgRef = ref(storage, path)
      // await uploadBytes(imgRef,thumbnail)
      // const imgUrl = await getDownloadURL(imgRef)

      

      // create a user document
      let storageRef = collection(db,"users")
      await setDoc(doc(storageRef,res.user.uid),{
                online: true,
                displayName,
        })

        // add display AND PHOTO_URL name to user
        await updateProfile(res.user,{ displayName })

      // dispatch login action
      dispatch({ type: 'LOGIN', payload: res.user })

      if (!isCancelled) {
        setIsPending(false)
        setError(null)
      }
    } 
    catch(err) {
      if (!isCancelled) {
        setError(err.message)
        setIsPending(false)
      }
    }
  }

  useEffect(() => {
    return () => setIsCancelled(true)
  }, [])

  return { signup, error, isPending }

}
